import { LayoutProps } from "../../components/LayoutWrapper";
import * as React from 'react';
import { HeaderMenu } from "../../components/HeaderMenu";
import { Helpers } from "../../utils/helpers";
import axios from 'axios';
import { UserInfo, UserInfoForm } from "../../components/UserInfo";
import { groupBy, mapValues } from 'lodash';


interface UserCreateState {
    loading: boolean;
    serverErrors: {[field: string]: string[]}
}

interface UserCreateProps extends LayoutProps{
}

export class UserCreate extends React.Component<UserCreateProps, UserCreateState> {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            serverErrors: {}
        };
    }

    createUser = async (user: UserInfo) => {
        this.setState({
            loading: true
        });
        console.log(user);

        try{
            const response = await axios.post('/api/users', user, {
                headers: {
                    Authorization: Helpers.getSessionId()
                },
            });

            Helpers.showSuccess('Lietotājs veiksmīgi izveidots!');
            this.props.history.push(`/users/${response.data.data}`);

            //redirect to edit page with success message
        }catch(error: any){
            this.setState({
                loading: false
            });
            if(error.response && error.response.status === 400){
                const errors = error.response.data.errors;

                this.setState({
                    serverErrors: mapValues(groupBy(errors,error => error.param), errors => errors.map(error => error.msg))
                })

                console.log(mapValues(groupBy(errors,error => error.param), errors => errors.map(error => error.msg)))

                console.log(this.state.serverErrors);
            }else{
                Helpers.showError("Kaut kas nogāja greizi!");
            }
        }
    }

    onValueChanged = (field) => {
        const errors = this.state.serverErrors;
        errors[field] = [];
        this.setState({
            serverErrors: errors
        });
    }

    render() {
        return (
            <div>
                <header style={{ background: "#fff" }}>
                    <div className="layout-wrapper">
                        <HeaderMenu { ...this.props }/>
                    </div>
                </header>

                <div className="layout-wrapper">
                    <UserInfoForm onSubmit={this.createUser} type='create' loading={this.state.loading} onValueChanged={this.onValueChanged} serverErrors={this.state.serverErrors}/>
                </div>
            </div>
        )
    }
}

